import React from 'react';
import './Portfolio.css';
import SectionHeader from '../SectionHeader/SectionHeader';

const Portfolio = () => {
  return (
    <div className="Portfolio__container">
      <SectionHeader title="Portfolio" />
    </div>
  );
};

export default Portfolio;
